import React, { useState } from 'react'
import { Spinner } from 'reactstrap';
import { displayErrorAlert } from '../../utils/Utils';
import { axiosGet, axiosPost } from '../../utils/AxiosApi';
import { fileIconPath, URL } from '../../utils/Constants';
import swal from "sweetalert";
import DragDropFile from '../../UI/DragDropFile';
import CustomButton from '../common/CustomButton';

const ImportAdmission = () => {
    const [spinner, setSpinner] = useState(false);
    const [admissionFile, setAdmissionFile] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);
    const [iconPreview, setIconPreview] = useState(null);
    const [fileName, setFileName] = useState(null);

    const generateFormat = () => {
        setSpinner(true);

        axiosGet(
            URL.generateAdmissionFormat,
            (response) => {
                if (response.status === 200) {
                    setSpinner(false);
                    window.open(
                        URL.downloadBill + response.data.path,
                        "_blank"
                    );
                }
            },
            (err) => {
                displayErrorAlert(err);
                setSpinner(false);
            }
        );
    };

    const handleChange = (e) => {
        let files = e.target.files[0];
        let icon;
        let fileName;
        if(!!files){
            const extension = files.name.split('.').pop().toLowerCase();
                    const isFileSupported = extension.match(/(xlsx|xls)/);
                    if(fileIconPath[extension] && !!isFileSupported){
                        icon = fileIconPath[extension];
                        fileName = files.name;
                        setAdmissionFile(files);
                    }else{
                        icon =fileIconPath.default;;
                        fileName = fileName = files.name + " appears to be in a format that is not supported."
                        setAdmissionFile(null);
                    }
                    setFileName(fileName);
                    setIconPreview(icon);
        }else{
            setFileName(null);
            setIconPreview(null);
            setAdmissionFile(null);
        }
    };

     const handleFileDrop = (e, name) => {
        let files = e.dataTransfer.files[0];
        let icon;
        let fileName;
        if (files.length > 1) {
              swal("Oops", "Please select only one file");
            } else {
                if(!!files){
                    const extension = files.name.split('.').pop().toLowerCase();
                    const isFileSupported = extension.match(/(xlsx|xls)/);
                    if(fileIconPath[extension] && !!isFileSupported){
                        icon = fileIconPath[extension];
                        fileName = files.name;
                        setAdmissionFile(files);
                    }else{
                        icon =fileIconPath.default;;
                        fileName = fileName = files.name + " appears to be in a format that is not supported."
                        setAdmissionFile(null);
                    }
                    setFileName(fileName);
                    setIconPreview(icon);
                }else{
                    setFileName(null);
                    setIconPreview(null);
                    setAdmissionFile(null);
                }
            }
      };

    const importFile = () => {
        let formData = new FormData();
        if (admissionFile !== null) {
            formData.append("file", admissionFile);

            setSpinner(true);

            axiosPost(
                URL.importAdmission,
                formData,
                (response) => {
                    if (response.status === 200) {
                        setAdmissionFile(null);
                        setFileName(null);
                        setIconPreview(null);
                        setSpinner(false);
                        swal("Success", "Admission data imported successfully.");
                    }
                },
                (err) => {
                    swal("Opps!",err.response.data.message);
                    setSpinner(false);
                }
            );
        } else {
            swal("Info", "Empty file cannot be imported");
        }
    };

    return (
        <>
            {spinner ? (
                <div className="fullWindow-Spinner">
                    <div>
                        <Spinner color="white"></Spinner>
                    </div>
                    <div style={{ fontSize: "16px", marginTop: "15px" }}>
                        Please wait...
                    </div>
                </div>
            ) : null}
            <div className="container">
                <div className="d-flex justify-content-between py-2 align-items-center">
                    <div className="">
                        To import the admission data, the format should be according to
                        the system. Please do not change the content of the file.
                        <br /> Generate the admission format here.
                        <br/>
                        <span className="text-danger font-italic">
                            [Note: all columns in the file are mandatory]
                        </span>
                    </div>
                    {
                        <button
                            className="tt-button tt-button-primary"
                            onClick={generateFormat}
                        >
                            Generate Format
                        </button>
                    }
                </div>
                <div className="py-2">
                      <DragDropFile
                                multiple={false}
                                handleChange={(e) => handleChange(e)}
                                name="admissionFile"
                                handleFileDrop={handleFileDrop}
                                files={admissionFile}
                                accept=".xlsx, .xls"
                                iconPreview={iconPreview}
                                fileName={fileName}
                                 id="admissionFile"
                              />
                    <div className="mt-3 text-right">

                        <button
                            className="tt-button tt-button-primary"
                            onClick={importFile}
                        >
                            Import
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ImportAdmission
